/* Hero "Just in" card: quietly moves through the newest pieces, in a different order on every visit.
   Pauses on hover, when the tab is hidden, and when the hero scrolls out of view. */
(function () {
  if (customElements.get('mj-hero')) return;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var STEP = 5200;

  class MjHero extends HTMLElement {
    connectedCallback() {
      var pieces;
      try { pieces = JSON.parse(this.querySelector('[data-pieces]').textContent) || []; } catch (e) { pieces = []; }
      this.card = this.querySelector('[data-card]');
      if (!pieces.length || !this.card) return;
      for (var i = pieces.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = pieces[i]; pieces[i] = pieces[j]; pieces[j] = t; }
      this.pieces = pieces;
      this.index = 0;
      this.img = this.card.querySelector('[data-img]');
      this.bar = this.card.querySelector('[data-progress]');
      this.fill(pieces[0]);
      this.card.hidden = false;
      if (reduce || pieces.length < 2) return;

      this.paused = false;
      this.visible = true;
      this.elapsed = 0;
      this.last = performance.now();
      var self = this;
      this.card.addEventListener('mouseenter', function () { self.paused = true; });
      this.card.addEventListener('mouseleave', function () { self.paused = false; self.last = performance.now(); });
      this.card.addEventListener('focus', function () { self.paused = true; });
      this.card.addEventListener('blur', function () { self.paused = false; self.last = performance.now(); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) { self.visible = entries[0].isIntersecting; self.last = performance.now(); }).observe(this);
      }
      requestAnimationFrame(this.tick.bind(this));
    }

    fill(p) {
      this.card.href = p.u;
      this.img.src = p.i;
      this.card.querySelector('[data-name]').textContent = p.t;
      this.card.querySelector('[data-price]').textContent = p.p;
      this.card.querySelector('[data-meta]').textContent = p.m || '';
      this.card.setAttribute('aria-label', 'Just in: ' + p.t + ', ' + p.p);
      var next = this.pieces[(this.pieces.indexOf(p) + 1) % this.pieces.length];
      if (next) { var pre = new Image(); pre.src = next.i; }
    }

    tick(now) {
      var dt = now - this.last;
      this.last = now;
      if (!this.paused && this.visible && !document.hidden) this.elapsed += dt;
      this.bar.style.width = Math.min(100, (this.elapsed / STEP) * 100) + '%';
      if (this.elapsed >= STEP) {
        this.elapsed = 0;
        this.index = (this.index + 1) % this.pieces.length;
        var self = this, p = this.pieces[this.index];
        this.card.classList.add('is-changing');
        setTimeout(function () { self.fill(p); self.card.classList.remove('is-changing'); }, 450);
      }
      requestAnimationFrame(this.tick.bind(this));
    }
  }
  customElements.define('mj-hero', MjHero);
})();
